import React from 'react';
import { Check, Plus, Sparkles } from 'lucide-react';
import { cn } from '../lib/utils';

const ExtrasSelector = ({ extras, selectedExtras, onToggleExtra, loading }) => {
  if (loading) {
    return (
      <div className="animate-pulse space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-20 bg-zinc-800 rounded-lg" />
        ))}
      </div>
    );
  }

  if (!extras || extras.length === 0) {
    return null;
  }

  const formatPrice = (cents) => {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-white">Servicios Extras</h3>
      </div>
      
      <div className="grid gap-3">
        {extras.map((extra) => {
          const isSelected = selectedExtras.includes(extra.id);
          
          return (
            <button
              key={extra.id}
              type="button"
              onClick={() => onToggleExtra(extra.id)}
              className={cn(
                "w-full p-4 rounded-lg border-2 transition-all text-left",
                "flex items-start gap-4",
                isSelected 
                  ? "border-primary bg-primary/10" 
                  : "border-zinc-700 bg-zinc-900/50 hover:border-zinc-600"
              )}
              data-testid={`extra-option-${extra.id}`}
            >
              {/* Checkbox visual */}
              <div className={cn(
                "w-6 h-6 rounded-md flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors",
                isSelected 
                  ? "bg-primary text-black" 
                  : "bg-zinc-800 border border-zinc-600"
              )}>
                {isSelected && <Check className="w-4 h-4" />}
              </div>
              
              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <h4 className={cn(
                      "font-medium",
                      isSelected ? "text-primary" : "text-white"
                    )}>
                      {extra.name}
                    </h4>
                    {extra.description && (
                      <p className="text-sm text-zinc-400 mt-1 line-clamp-2">
                        {extra.description}
                      </p>
                    )}
                  </div>
                  <span className={cn(
                    "font-bold whitespace-nowrap",
                    isSelected ? "text-primary" : "text-white"
                  )}>
                    +{formatPrice(extra.price_cents)}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      
      {selectedExtras.length > 0 && (
        <div className="mt-4 p-3 bg-primary/10 rounded-lg border border-primary/30">
          <p className="text-sm text-primary">
            <span className="font-medium">{selectedExtras.length}</span> extra{selectedExtras.length > 1 ? 's' : ''} seleccionado{selectedExtras.length > 1 ? 's' : ''}
          </p>
        </div>
      )}
    </div>
  );
};

export default ExtrasSelector;
